
import { Options, Vue } from 'vue-class-component';
import mapConfig from "@/config/map";
import EventBusService from "@/services/EventBusService";
import RegionService from "@/services/RegionService";
import CourseMarker from "@/components/google-maps/CourseMarker.vue";
import LocationMarker from "@/components/google-maps/LocationMarker.vue";
import UserMarker from "@/components/google-maps/UserMarker.vue";
import { Position } from "@/data/maps";
import { Location } from "@/data/location";
import { Course } from "@/data/course";
import RegionSelectList from "@/components/RegionSelectList.vue";
import { getMapStyles } from "@/utils/google-maps";

//import * as google from '@types/google.maps';
import { Loader as GoogleMapsLoader } from '@googlemaps/js-api-loader';

const mapsLoader = new GoogleMapsLoader({
    apiKey: mapConfig.apiKey,
    version: 'quarterly',
    libraries: ['places', 'geometry'],
});


@Options({
    props: {
        regionId: {
            type: Number,
            required: true,
        }
    },
    components: {
        LocationMarker,
        CourseMarker,
        UserMarker,
        RegionSelectList,
    },
})
export default class RegionSelect extends Vue {
    regionId!: number

    google: any = null
    map: any = null
    // service: any = null

    loading = true
    loadingService = false
    loadingAutolocate = false
    mapInitialized = false

    locations: Location[] = []
    courses: Course[] = []

    get coursesWithCoordinates() {
        return this.courses.filter(course => course.gathering_lat && course.gathering_lng);
    }

    onCourseMarkerClick(course: Course): void {
        // console.log('X marker clicked:', region);
        // this.setLocation(region.lat , region.lng);
        EventBusService.$emit('modals.course.details.open', {course});
        /*setTimeout(() => {
            // this.scrollToResults();
            console.log('onCourseMarkerClick', course);
        }, 800);*/
        //this.searchText = region.lat + ',' + region.lng;
        //this.searchSubmit();
    }

    initRegionsMap() {
        // maps and list of regions are loaded when this gets called
        // this.service = new this.google.maps.places.PlacesService(this.map);
        this.fitMapViewport(null, this.coursesWithCoordinates, this.locations);
    }


    /*
    setLocation(lat: number, lng: number) {
        this.userPosition = {lat, lng};

        const distanceSorted = this.getRegionsByDistance(this.userPosition);
        //console.log(distanceSorted.map(({name, distance}) => ({name, distance})));

        this.fitMapViewport(this.userPosition, distanceSorted/ *.slice(0, 5)* /);
        //showAddressMarker = true;

        this.regionsDistanced = distanceSorted;
    }
    */


    fitMapViewport(center: Position|null, courses: Course[] = [], locations: Location[] = []) {
        const bounds = new this.google.maps.LatLngBounds();

        if( !center && !courses.length ) {
            return;
        }

        // console.log(center, courses);

        if( center ) {
            bounds.extend(center);
        }

        courses.forEach(course => bounds.extend({lat: course.gathering_lat, lng: course.gathering_lng})); // we parsed the strings to floats after loading
        locations.forEach(location => bounds.extend({lat: location.lat, lng: location.lng})); // we parsed the strings to floats after loading

        this.map.setCenter(bounds.getCenter());

        //this.map.fitBounds(bounds, mapConfig.proximitySearch.fitPadding);

        const map = this.map;

        this.google.maps.event.addListenerOnce(map, 'idle', function() {
            map.fitBounds(bounds, mapConfig.proximitySearch.fitPadding);
        });

        if( (courses.length + locations.length) === 1 && !center ) {
            // no user location and only a single store
            this.map.setZoom(6);
        }

        if( mapConfig.proximitySearch.debug ) {
            const rectangle = new this.google.maps.Rectangle({
                map: this.map,
                bounds: bounds,
                strokeColor: "#00AA00",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#00AA00",
                fillOpacity: 0.35,
            });
        }
    }

    loadGoogleMaps() {
        return mapsLoader.load().then(google => {
            const mapOptions = {
                center: {
                    // center of Germany
                    lat: 51.1642292,
                    lng: 10.4541194,
                },
                zoom: 6,
                streetViewControl: false,
                styles: getMapStyles(),
            };

            this.google = google;
            this.map = new google.maps.Map(this.$refs.gmap as HTMLElement, mapOptions);
        }).then(() => this.mapInitialized = true);
    }

    loadCourses() {
        this.loading = true;
        return RegionService.getRegionCourses(this.regionId as number).then(result => {
            const locations: Location[] = [];
            this.courses = (result.data.data || []).map((course: any) => {
                if( course.location?.id && !locations.some(location => location.id === course.location?.id) ) {
                    locations.push({
                        ...course.location,
                        lat: parseFloat(course.location.lat),
                        lng: parseFloat(course.location.lng),
                    });
                }

                return {
                    ...course,
                    gathering_lat: parseFloat(course.gathering_lat),
                    gathering_lng: parseFloat(course.gathering_lng),
                };
            });
            this.locations = locations;
        }).finally(() => this.loading = false);
    }

    /*
    getRegionsByDistance(position: Position): DistanceRegion[] {
        const distancedRegions = this.regions.map((region: Region): DistanceRegion => ({
            ...region,
            distance: this.google.maps.geometry.spherical.computeDistanceBetween(
                new this.google.maps.LatLng(position),
                new this.google.maps.LatLng(region)
            ),
        }));

        return distancedRegions.sort((a, b) => a.distance - b.distance);
    }
    */

    mounted() {
        Promise.all([
            this.loadCourses(),
            this.loadGoogleMaps(),
        ]).then(() => {
            this.initRegionsMap();
        });
    }
}
